import 'https://av.archive.org/js/playset.js';

// eslint-disable-next-line import/no-named-as-default
import $ from '../util/jquery.js';

import '../archive/archive.js';
import '../flags/flags.js';

/* Add To User List Button */
import '../ia-item-userlists/ia-item-userlists.js';


$(() => {
  $('#ia-carousel').each((_idx, e) => {
    import('https://esm.archive.org/bootstrap@^3.0.0').then(() => {
      $(e).on('slide.bs.carousel', (event) => {
        const numImages = $('#ia-carousel').find('img[data-index]').length;
        const nextImage = $(event.relatedTarget).find('img[data-index]');
        nextImage.attr('src', nextImage.data('lazy-src'));
        nextImage.removeAttr('data-lazy-src');
        if (!$('body').hasClass('jwaudio'))
          history.replaceState({}, '', nextImage.data('uri'));
        $('.carousel-pagination').html(
          `${nextImage.data('index') + 1} / ${numImages}`,
        );
      });
    });
  });
});
